import { render } from "./IconClinicInfo.vue?vue&type=template&id=4aa4ec18&lang=html"
import script from "./IconClinicInfo.vue?vue&type=script&lang=js"
export * from "./IconClinicInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__